import { HomeLicensesCopyCode } from 'features/home/components/HomeLicensing/AvailableLicenses/HomeLicensesGroupsTable/HomeLicensesGroup/styles'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import MobileLabelLine from 'components/MobileWhiteCardLine'
import { LicenseType } from 'features/licenses/types'

import Note from '../LicensesGroupsTable/Note'
import CopyCode from '../LicensesGroupsTable/CopyCode'
import { ReclaimLicenseMobileContainer } from '../ReclaimLicenseModal/styles'
import SelectedLicenseDescriptionCell from './SelectedLicenseDescriptionCell'

interface SelectedLicenseMobileProps {
  values: Record<string, any>
  original: LicenseType
}

/**
 * @todo localization
 */

function SelectedLicenseMobile({ original }: SelectedLicenseMobileProps) {
  return (
    <ReclaimLicenseMobileContainer>
      <SelectedLicenseDescriptionCell license={original} />
      <HomeLicensesCopyCode>
        <CopyCode code={original.code} />
      </HomeLicensesCopyCode>
      <MobileLabelLine label="Order Number" value={original.orderNumber} />
      <MobileLabelLine label="Purchase Order" value={original.customerPO} />
      <MobileLabelLine
        label="Created"
        value={
          <IntlFormattedDate
            date={original.created}
            withTime
            defaultReturn="-"
          />
        }
      />
      <Note original={original} disableEdit />
    </ReclaimLicenseMobileContainer>
  )
}

export default SelectedLicenseMobile
